import React from "react";

export default function Support() {
  return (
    <div className="privacyPolicyDiv">
      <div
        // style={{
        //   display: "flex",
        //   alignItems: "center",
        //   backgroundColor: "red",
        // }}
        style={{ textAlign: "center" }}
      >
        <img
          style={{
            objectFit: "contain",
            height: 50,
            borderRadius: 10,
            // marginTop: 20,
            marginBottom: 10,
            //   margin: "auto    ",
          }}
          src={require("../assets/icon.png")}
          // src='https://firebasestorage.googleapis.com/v0/b/clothing-for-ukraine.appspot.com/o/Clothing%20For%20Ukraine%20Logo.jpg?alt=media&token=c75af262-0d8a-4184-b18e-3b7de7fd5363'
          alt=""
        />
      </div>
      {/* <div style={{ textAlign: "center", marginBottom: 10 }}>
        <img
          //   className="homeImage"
          style={{ objectFit: "contain", maxWidth: "500px", borderRadius: 10 }}
          src={require("../assets/homePic.jpg")}
          // src='https://firebasestorage.googleapis.com/v0/b/clothing-for-ukraine.appspot.com/o/Clothing%20For%20Ukraine%20Logo.jpg?alt=media&token=c75af262-0d8a-4184-b18e-3b7de7fd5363'
          alt=""
        />
      </div> */}
      <h1 className="privacyParagraph">Welcome to ChowDown Support</h1>
      <p className="privacyParagraph">
        ChowDown provides freshly cooked Chinese food for $10 and free delivery
        to any address in Davis, California. Our mouth-watering menu is freshly
        cooked in Davis and quickly delivered to you so you can conveniently
        enjoy a hot and tasty meal.
      </p>
      <p className="privacyParagraph boldTitle">Contact Us</p>
      <p className="privacyParagraph">Email: hellochowdown@gmail.com</p>
      <p className="privacyParagraph">
        We are here to help! Feel free to email us with any feedback, comments,
        or questions you have!
      </p>
    </div>
  );
}
